/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkTransferAliasToMainAccountRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {BulkTransferAliasToMainAccountResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const bulkTransferAliasToMainAccount = (request: BulkTransferAliasToMainAccountRequest, options?: CashRequestOptions) => post<BulkTransferAliasToMainAccountRequest, BulkTransferAliasToMainAccountResponse>("/2.0/cash/bulk-transfer-alias-to-main-account", request, {...options, rejectOnError: true })